import { render, staticRenderFns } from "./SubirArchivos.vue?vue&type=template&id=342b6f98&"
import script from "./SubirArchivos.vue?vue&type=script&lang=js&"
export * from "./SubirArchivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports